import DialogPreview from 'components/DialogPreview/DialogPreview'
import { Grid, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { FnDialog, I18n, ParseHtml } from 'utilities/utilities';
import { TableContainer, Paper, Table, TableHead, TableRow, TableCell, TableBody, styled } from '@mui/material';
import "./../../../../FrontEnd/Project/StyleProject.css";

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const ModalExtendPeriod = ({ isOpen, setIsOpen, lstDataAll }) => { //Pop Up > ประวัติการดำเนินการขยายระยะเวลา และปรับแผนโครงการ

    const [lstExtendPeriod, setlstExtendPeriod] = useState([]);

    useEffect(() => {
        if (isOpen && (lstDataAll || []).length > 0) {
            setlstExtendPeriod(lstDataAll)
        }
    }, [isOpen, lstDataAll])

    const handleClose = () => {
        setIsOpen(false);
    }

    return (
        <DialogPreview
            IsOpen={isOpen}
            Title={"ประวัติการดำเนินการขยายระยะเวลา และปรับแผนโครงการ"}
            required={false}
            sMaxWidth="lg"
            onClose={handleClose}
            JsxDialogAction
        >
            <Grid container spacing={1} justifyContent={"start"} alignItems={"start"} style={{ padding: '1%', paddingTop: '2% !important', }}>
                <TableContainer id='table-ExtendPeriod' component={Paper}>
                    <Table sx={{ minWidth: 1000 }}>
                        <TableHead>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ minWidth: '60px', width: '60px' }} rowSpan={2}></TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '180px', width: '180px' }} rowSpan={2}>ดำเนินการ</TableCell>
                                <TableCell component="th" padding='none' style={{ minWidth: '180px', width: '180px' }} rowSpan={2}>วันที่ดำเนินการ</TableCell>
                                <TableCell component="th" padding='none' style={{ backgroundColor: '#0056b3', minWidth: '200px', width: '200px' }} colSpan={2}>ก่อนแก้ไข</TableCell>
                                <TableCell component="th" padding='none' style={{ backgroundColor: '#3bb0a2', minWidth: '200px', width: '200px' }} colSpan={2}>หลังแก้ไข</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell component="th" padding='none' style={{ backgroundColor: '#c4dbfe', color: '#3e3e3e', minWidth: '100px', width: '100px' }}>วันที่เริ่มต้นโครงการ</TableCell>
                                <TableCell component="th" padding='none' style={{ backgroundColor: '#c4dbfe', color: '#3e3e3e', minWidth: '100px', width: '100px' }}>วันที่สิ้นสุดโครงการ</TableCell>
                                <TableCell component="th" padding='none' style={{ backgroundColor: '#b8fef6', color: '#3e3e3e', minWidth: '100px', width: '100px' }}>วันที่เริ่มต้นโครงการ</TableCell>
                                <TableCell component="th" padding='none' style={{ backgroundColor: '#b8fef6', color: '#3e3e3e', minWidth: '100px', width: '100px' }}>วันที่สิ้นสุดโครงการ</TableCell>
                            </TableRow>
                        </TableHead>  
                            {(lstExtendPeriod || []).length === 0 ?
                                <StyledTableRow key={`sID_ExtendPeriod_`}>
                                    <TableCell align="center" colSpan={7} style={{ padding: '3%' }}>ไม่พบข้อมูล</TableCell>
                                </StyledTableRow>
                                :
                                <TableBody>
                                    {(lstExtendPeriod || []).map((iTems) => {
                                        return (                                            
                                            <TableRow key={`sID_ExtendPeriod_${iTems.nID}`}>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.nOrder + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="left">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.sStatusName + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.sUpdateDate + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.sStartDateBefore + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.sEndDateBefore + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.sStartDateAfter + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Grid item xs={12} md={12}>
                                                        <Typography variant='body2'>{ParseHtml(iTems.sEndDateAfter + "")}</Typography>
                                                    </Grid>  
                                                </TableCell>
                                            </TableRow>                                            
                                        )
                                    })}
                                </TableBody>
                            }                    
                    </Table>
                </TableContainer>
            </Grid>
        </DialogPreview>
    )
}

export default ModalExtendPeriod
